import workspaceQuery from 'graphql/queries/vat/VatRateWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/vat/VatRateListQuery.graphql';
import instanceQuery from 'graphql/queries/vat/VatRateQuery.graphql';
import defaultQuery from 'graphql/queries/vat/VatRateDefault.graphql';
import mutationQuery from 'graphql/mutations/vat/VatRateMutation.graphql';
import fragment from 'graphql/fragments/vat/VatRateFragment.graphql';

const VatRate = {
  type: 'VatRate',
  title: 'VAT Rates',
  formTitle: 'VAT Rate',
  formUrl: '/Vat/Rate/Details/',
  workspaceUrl: '/Vat/Rate/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'rate',
  },
  fragment,
  screenReference: 'VAT_RATES',
};

export default VatRate;
